import { Col, Row, Typography } from 'antd';
import PropTypes from 'prop-types';
import moment from 'moment';
import React from 'react';
import constants from '../../../../config/api/constants';
import { useDictionaryTranslation } from '../../../../hooks/useDictionaryTranslation';

export const AudioComponent = ({ field }) => {
  const urlImage = constants.s3UrlPath;
  const formatAudioDate = (date) => date && moment(date).format('dddd DD MMMM YYYY (HH:mm:ss)');
  const { Title } = Typography;
  const { translate: t } = useDictionaryTranslation();

  return field.value ? (
    <Row>
      <Col md={24} key={field.idInput}>
        <Title level={5}>{field.label}</Title>
        <audio controls>
          <source src={`${urlImage}/${field?.value?.filename}`} type="audio/mpeg" />
          <track kind="captions" />
        </audio>
        <p>
          {formatAudioDate(field?.value?.time)}
        </p>
      </Col>
    </Row>
  ) : (
    <Row>
      <Col md={24}>
        <Title level={5}>{field.label}</Title>
        <p>{t('noAttachments')}</p>
      </Col>
    </Row>
  );
};

AudioComponent.propTypes = {
  field: PropTypes.object.isRequired,
};
